import { render, staticRenderFns } from "./menuItemTable.vue?vue&type=template&id=d606939e"
import script from "./menuItemTable.vue?vue&type=script&lang=js"
export * from "./menuItemTable.vue?vue&type=script&lang=js"
import style0 from "./menuItemTable.vue?vue&type=style&index=0&id=d606939e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports